import {searchApi, searchData} from "../search-api/search-api";
import {datalayerPush} from "../datalayer-push/datalayer-push";

export const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

const searchForms = document.querySelectorAll<HTMLFormElement>('.f-search');

searchForms.forEach(form => {
  const input = form.querySelector<HTMLInputElement>('.f-text__input');
  const dropdownWrapper = form.querySelector<HTMLElement>('.f-search__dropdown-content');

  const searchFetch = async (value) => {
    form?.classList.add("--searching");

    const response = form.classList.contains('--herbs')
      ? await searchApi.searchHerbs(value)
      : await searchApi.search(value);

    if (response && response.ok) {
      const data = (await response.json()) as searchData;
      console.log(data);

      if (!data.success) {
        form.classList.remove("--searching");
        return;
      }

      if (dropdownWrapper) dropdownWrapper.innerHTML = "";
      dropdownWrapper?.insertAdjacentHTML("beforeend", data.html);

      if (data.datalayerPush) datalayerPush(data.datalayerPush)
    }

    form?.classList.remove("--searching");
  }

  const debouncedFetch = debounce(async (value) => searchFetch(value), 300);

  input?.addEventListener('input', () => {
    if (input.value.length == 3) searchFetch(input.value)

    if (input.value.length >= 3) {
      debouncedFetch(input.value);
      form.classList.remove("--first-search");
    }
    else form.classList.add("--first-search");
  });
});
